import crud_actions from './crud_actions'
export const CLEAR_TAGS = 'clear_tags'

export const suggestTags = crud_actions.read('tags', 'suggestTags')

export const clearSuggestedTags = opts => {
  return {
    type: CLEAR_TAGS,
    payload: opts
  }
}
